// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"b7aa46fc","557":"ddcbd9b4","710":"aa8a63c7"}[chunkId] + ".chunk.js";
};